import * as THREE from 'three';

type WallMaterialState = {
  __wallOriginalOpacity?: number;
  __wallOriginalTransparent?: boolean;
  __wallOriginalDepthWrite?: boolean;
};

export function isApartmentWallDomain(domain: Record<string, unknown>): boolean {
  const objectKind = String(domain.objectKind ?? '').toLowerCase();
  const wallKind = String(domain.wallKind ?? '').toLowerCase();
  if (objectKind === 'apartment_shell' && ['interior', 'exterior', 'wall_face'].includes(wallKind)) {
    return true;
  }
  const visual = domain.visualSurface && typeof domain.visualSurface === 'object'
    ? domain.visualSurface as Record<string, unknown>
    : {};
  if (['wall_exterior', 'wall_interior', 'wall_partition', 'wall_face'].includes(
    String(visual.role ?? '').toLowerCase(),
  )) return true;
  // 03.10: билдер-стены несут objectKind вида partition_wall/exterior_wall
  // (apartment_graph) — без этой ветки авто-скрытие не видело НИ ОДНОЙ
  // стены прод-квартиры (фидбек: «стены опять торчат»).
  const role = String(domain.role ?? '').toLowerCase();
  if (['wall_exterior', 'wall_interior', 'wall_partition', 'wall_face'].includes(role)
    || role.startsWith('wall_')) return true;
  if (objectKind.endsWith('wall') || objectKind.endsWith('wall_face')) return true;
  // торцевые заглушки стен (wallCap) — та же ограждающая поверхность,
  // без этого они остаются «колоннами» при скрытых стенах
  return domain.wallCap === true;
}

export function applyWallTransparency(object: THREE.Object3D, enabled: boolean, opacity = 0.3): void {
  object.traverse((descendant) => {
    const mesh = descendant as THREE.Mesh;
    if (!mesh.material) return;
    const materials = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
    for (const material of materials) {
      const state = material.userData as WallMaterialState;
      if (enabled) {
        if (state.__wallOriginalOpacity === undefined) {
          state.__wallOriginalOpacity = material.opacity;
          state.__wallOriginalTransparent = material.transparent;
          state.__wallOriginalDepthWrite = material.depthWrite;
        }
        material.opacity = opacity;
        material.transparent = true;
        material.depthWrite = false;
      } else if (state.__wallOriginalOpacity !== undefined) {
        material.opacity = state.__wallOriginalOpacity;
        material.transparent = state.__wallOriginalTransparent ?? false;
        material.depthWrite = state.__wallOriginalDepthWrite ?? true;
        delete state.__wallOriginalOpacity;
        delete state.__wallOriginalTransparent;
        delete state.__wallOriginalDepthWrite;
      }
      material.needsUpdate = true;
    }
  });
}
